import { render, staticRenderFns } from "./ResetMigrationButton.vue?vue&type=template&id=7f17ad8e&"
import script from "./ResetMigrationButton.vue?vue&type=script&lang=js&"
export * from "./ResetMigrationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports